import React, { ReactElement } from 'react';
import { Button } from '@material-ui/core';

export const Translations = {};

const Configuration = {};

interface IData {
  name: string;
  code: number;
  population: string;
  size: string;
}

export const DummyColumns = [
  {
    label: 'Population',
    id: 'population',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Size',
    id: 'size',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Name',
    id: 'name',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Code',
    id: 'code',
    // align: 'right',
    align: 'left',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <React.Fragment>{cellValue}</React.Fragment>
    ),
    inData: true,
  },
  {
    label: 'Action1',
    id: 'action_1',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <Button variant="contained" color="secondary">
        Press Action 1
      </Button>
    ),
    inData: false,
  },
  {
    label: 'Action2',
    id: 'action_2',
    render: (rowIndex: number, cellValue: any, columnIndex: number) => (
      <Button>Press Action 2</Button>
    ),
    inData: false,
  },
  {
    label: 'Calculate Field',
    id: 'cal_1',
    render: (
      rowIndex: number,
      cellValue: any,
      columnIndex: number,
      data: IData[]
    ) => <p>{`${data[rowIndex].code} _ ${data[rowIndex].name}`}</p>,
    inData: false,
  },
];

export const DummyData: IData[] = [
  {
    size: '1csacscsaca11',
    name: 'ssvfvfvfvs',
    code: 1234,
    population: 'ddscccsd',
  },
  {
    size: '111',
    name: 'ssvvvvvvvvs',
    code: 2332,
    population: 'ddd',
  },
  {
    size: '1scscsc11',
    name: 'scsccsscss',
    code: 23232,
    population: 'dcscscscsscdd',
  },
  {
    size: '1scscsc11',
    name: 'scsccsscss',
    code: 22323,
    population: 'dcaascscscsscdd',
  },
  {
    size: '1scscsccsscs11',
    name: 'scsccsscss',
    code: 2121,
    population: 'ccss',
  },
  {
    size: '1csacscsaca11',
    name: 'ssvfvfvfvs',
    code: 2223,
    population: 'ddscccsd',
  },
  {
    size: '111',
    name: 'ssvvvvvvvvs',
    code: 2323,
    population: 'ddd',
  },
  {
    size: '1scscsc11',
    name: 'scsccsscss',
    code: 232323,
    population: 'dcscscscsscdd',
  },
  {
    size: '1scscsc11',
    name: 'scsccsscss',
    code: 232323,
    population: 'dcaascscscsscdd',
  },
  {
    size: '1scscsccsscs11',
    name: 'scsccsscss',
    code: 232323,
    population: 'ccss',
  },
];

export default Configuration;
